import { createReducer } from 'reduxsauce'
import { Types } from '../actions/cteActions'

const INITIAL_STATE = { loading: false, ctes: null, empresas: null }

const begin = (state = INITIAL_STATE, action) => {
    return { ...state, loading: true }
}
const success = (state = INITIAL_STATE, action) => {
    return { ...state, loading: false, ctes: action.payload.ctes, empresas: action.payload.empresas }
}
const failure = (state = INITIAL_STATE, action) => {
    return { ...state, loading: false, ctes: null, empresas: null }
}

const HANDLERS = {
    [Types.FETCH_CTE_BEGIN]: begin,
    [Types.FETCH_CTE_SUCCESS]: success,
    [Types.FETCH_CTE_FAILURE]: failure
}

export default createReducer(INITIAL_STATE, HANDLERS)